(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-concept-home"] && !Shopify.designMode) return;
  try {
    
  const gbRanges = text => (text.match(/\d+/g) || []).map(Number);
  function gbInit(root) {
    if (root.dataset.gbReady) return;
    root.dataset.gbReady = 'true';
    const grid = root.querySelector('[data-gb-grid]');
    const cards = [...root.querySelectorAll('[data-gb-card]')];
    cards.sort((a, b) => Number(b.dataset.gbAvailable === 'true') - Number(a.dataset.gbAvailable === 'true'));
    cards.forEach(card => grid.appendChild(card));
    const inputs = ['players', 'age', 'time'].map(key => root.querySelector(`[data-gb-${key}]`));
    const result = root.querySelector('[data-gb-results]');
    const more = root.querySelector('[data-gb-more]');
    let limit = 8;
    const update = () => {
      const [players, age, time] = inputs.map(input => Number(input.value));
      let count = 0;
      cards.forEach(card => {
        const people = gbRanges(card.dataset.players);
        const ages = gbRanges(card.dataset.age);
        const times = gbRanges(card.dataset.time);
        const openEnded = /of meer|or more|\d+\s*\+/i.test(card.dataset.players);
        const maximum = openEnded ? Infinity : Math.max(...people);
        const matches = (!players || (people.length && players >= Math.min(...people) && players <= maximum)) && (!age || (ages.length && age >= Math.min(...ages) && (ages.length < 2 || age <= Math.max(...ages)))) && (!time || (times.length && Math.max(...times) <= time));
        if (matches) count++;
        card.hidden = !matches || count > limit;
      });
      result.textContent = result.dataset.template.replace('[count]', count).replace('[shown]', Math.min(count, limit));
      more.hidden = count <= limit;
      root.querySelector('[data-gb-empty]').hidden = count > 0;
    };
    inputs.forEach(input => input.addEventListener('change', () => {limit = 8; update();}));
    more.addEventListener('click', () => {limit += 8; update();});
    root.querySelectorAll('[data-gb-reset]').forEach(button => button.addEventListener('click', () => {inputs.forEach(input => input.value = ''); limit = 8; update();}));
    root.querySelector('[data-gb-controls]').hidden = false;
    result.hidden = false;
    update();
  }
  document.querySelectorAll('[data-gb-home]').forEach(gbInit);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gb-home]').forEach(gbInit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-story-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.gbStoryReady) return;
      root.dataset.gbStoryReady = 'true';
      const track = root.querySelector('[data-gb-story-track]');
      const prev = root.querySelector('[data-gb-story-prev]');
      const next = root.querySelector('[data-gb-story-next]');
      if (!track) return;
      const step = () => {
        const card = track.querySelector('.gb-story__card');
        if (!card) return track.clientWidth;
        return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step() }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };
    const all = (scope) => scope.querySelectorAll('[data-gb-story]').forEach(init);
    all(document);
    document.addEventListener('shopify:section:load', (e) => all(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      const card = e.target.closest('.gb-story__card');
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
